module.exports = __webpack_public_path__ + "img/warning.387b8403.svg";